import { Trans } from '@lingui/macro'
import { styles } from 'helpers'
import React from 'react'
import { Typography } from 'webbook-airways'

export default function Unsaved() {
  return (
    <Typography
      variant="caption"
      style={{
        fontWeight: 700,
        color: styles.colors.paleRed,
        textTransform: 'uppercase',
        marginRight: 10
      }}
    >
      <Trans>Unsaved</Trans>
    </Typography>
  )
}
